var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isI18n
    ? _c(
        "b-modal",
        {
          attrs: {
            id: "operation-deactivate-modal-result",
            "data-cy": "operation-modal-result",
            "destroy-on-hide": false,
            "aria-role": "dialog",
            "aria-label": "Activar/Desactivar Operación",
            "has-modal-card": "",
            "trap-focus": "",
            "on-cancel": _vm.close,
            "aria-modal": "",
            width: "400",
          },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-card", staticStyle: { width: "auto" } },
            [
              _c("header", { staticClass: "modal-card-body" }, [
                _c("div", { staticClass: "modal-card-title modal-title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
                ]),
                _c("a", {
                  staticClass: "close-modal delete",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                }),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _vm.result.error
                    ? _c("div", [
                        _vm.result.error.length > 0
                          ? _c("p", [
                              _vm._v(
                                " " + _vm._s(_vm.$t("subtitleWithError")) + " "
                              ),
                            ])
                          : _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    !_vm.operation.isActive
                                      ? _vm.$t("subtitleActivated")
                                      : _vm.$t("subtitleDeactivated")
                                  ) +
                                  " "
                              ),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.result.error, function (item, index) {
                    return _c("ul", { key: index, staticClass: "pb-4" }, [
                      _c(
                        "li",
                        {
                          staticClass: "has-text-danger",
                          attrs: { id: "error-detail" },
                        },
                        [_vm._v(" - " + _vm._s(item) + " ")]
                      ),
                    ])
                  }),
                  _c("p", { staticClass: "has-text-weight-bold pb-0" }, [
                    _vm._v(" " + _vm._s(_vm.$t("operation")) + " "),
                    _c("span", { staticClass: "has-text-weight-normal" }, [
                      _vm._v(_vm._s(_vm.operation.companyOperationId)),
                    ]),
                  ]),
                  _c("p", { staticClass: "has-text-weight-bold pb-0" }, [
                    _vm._v(" " + _vm._s(_vm.$t("type")) + " "),
                    _c("span", { staticClass: "has-text-weight-normal" }, [
                      _vm._v(_vm._s(_vm.getOperationTypeTitle())),
                    ]),
                  ]),
                  _c("p", { staticClass: "has-text-weight-bold pb-0" }, [
                    _vm._v(" " + _vm._s(_vm.$t("clientIdNumber")) + " "),
                    _c("span", { staticClass: "has-text-weight-normal" }, [
                      _vm._v(
                        _vm._s(
                          _vm.operation.client
                            ? _vm.operation.client["idNumber"]
                            : ""
                        )
                      ),
                    ]),
                  ]),
                  _c("p", { staticClass: "has-text-weight-bold mt-4 pb-0" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          !_vm.operation.isActive
                            ? _vm.$t("operationActivated")
                            : _vm.$t("operationDeactivated")
                        ) +
                        " "
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-normal",
                        attrs: { id: "operation-activated" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.result.operationUpdated ? "SI" : "NO")
                        ),
                      ]
                    ),
                  ]),
                  _vm.result.disabledUser !== undefined
                    ? _c("p", { staticClass: "has-text-weight-bold pb-0" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              !_vm.operation.isActive
                                ? _vm.$t("userActivated")
                                : _vm.$t("userDeactivated")
                            ) +
                            " "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "has-text-weight-normal",
                            attrs: { id: "user-activated" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.result.disabledUser ? "SI" : "NO")
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c("p", { staticClass: "has-text-weight-bold pb-0" }, [
                    _vm._v(" " + _vm._s(_vm.$t("pendingTransactions")) + " "),
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-normal",
                        attrs: { id: "transaction-pending" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.result.pendingTransactions ? "SI" : "NO")
                        ),
                      ]
                    ),
                  ]),
                  _c("p", { staticClass: "has-text-weight-bold pb-0" }, [
                    _vm._v(" " + _vm._s(_vm.$t("walletBalance")) + " "),
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-normal",
                        attrs: { id: "client-balance" },
                      },
                      [
                        _vm._v(
                          "$" +
                            _vm._s(
                              _vm.result.clientBalance !== undefined
                                ? _vm.result.clientBalance
                                : "N/A"
                            )
                        ),
                      ]
                    ),
                  ]),
                  _vm.result.operationUpdated === true &&
                  _vm.result.clientBalance > 0
                    ? _c("p", { staticClass: "has-text-weight-bold pb-0" }, [
                        _vm._v(" " + _vm._s(_vm.$t("rememberTransfer1")) + " "),
                        _c("span", { attrs: { id: "remember-balance" } }, [
                          _vm._v("$" + _vm._s(_vm.result.clientBalance) + " "),
                        ]),
                        _vm._v(" " + _vm._s(_vm.$t("rememberTransfer2")) + " "),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "buttons is-pulled-right pt-5" },
                    [
                      _c("b-button", {
                        staticClass: "button is-button-secondary",
                        attrs: {
                          id: "operation-modal-button-no",
                          "data-cy": "operation-modal-button-no",
                          label: "Ok",
                          rounded: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }